import baseService from '@common/externos/services/base.service';
import store from '@common/store/store';

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;
const commonRoute = window.api_routes.smarAPD_Common;

let http = baseService(store, tbRoute);

let controller = '/MovimentacaoExterno/';

const apiDef = {
  consultarProtocoloByCpfCnpj(data, tokenRecaptcha) {
    return http.post(`${controller}ConsultaProtocoloByCpfCnpj`, { CpfCnpj: data }, tokenRecaptcha);
  },
  imprimirSolicitacao(numeroProtocolo, tokenRecaptcha) {
    return http.post(`${controller}ImprimirSolicitacao`, { numeroProtocolo: numeroProtocolo }, tokenRecaptcha);
  },
  imprimirSolicitacaoGrid(numeroProtocolo) {
    return http.post(`${controller}ImprimirSolicitacaoGrid`, { numeroProtocolo: numeroProtocolo });
  },
};

export default apiDef;
